const ICON_FILL_COLOR_CSS_VARIABLE = '--icon-fill-color'

export const getColorVariable = (defaultColor?: string) =>
  `var(${ICON_FILL_COLOR_CSS_VARIABLE}, ${defaultColor})`

export const createColor = (color?: string): Record<string, string | undefined> => ({
  [ICON_FILL_COLOR_CSS_VARIABLE]: color,
})
